import AbstractIceContentController from '../../../abstract/ice-content/controller';

class Controller extends AbstractIceContentController {
    constructor(widget) {
        super(widget);

        this.init();
    }

    init() {
        window.App.Utils.Object.nodeListToArray(
            this.getSelectors('.js-widget-faq__open-faq')
        ).forEach(btn => {
            btn.addEventListener('click', () => {
                btn.parentNode.classList.toggle('widget-faq__opened'); // Use to show the answer
            });
        });
    }
}

export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-faq/widget/scripts/controller.js